<div style="height:calc(100vh - 50px);height:calc(100dvh - 50px);margin: 20px;">
    <full-calendar [options]="calendarOptions"></full-calendar>
</div>

<!-- <div class="calendar-filters d-flex align-items-center gap-3 mb-2">
    <label class="d-flex align-items-center gap-1">
        <input type="checkbox" [checked]="showEvents" (change)="onToggleEvents($event)" />
        <span>Events</span>
    </label>

    <label class="d-flex align-items-center gap-1">
        <input type="checkbox" [checked]="showTasks" (change)="onToggleTasks($event)" />
        <span>Tasks</span>
    </label>
</div>

<div style="height:calc(100vh - 50px);height:calc(100dvh - 50px);margin: 20px;">
    <full-calendar [options]="calendarOptions"></full-calendar>
</div> -->